/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { subscriptionAccessDataReasonSchema } from './SubscriptionAccessDataReasonSchema'

export const subscriptionAccessDataSchema = z.object({
	hasAccess: z.boolean(),
	reason: subscriptionAccessDataReasonSchema,
	endsAt: z.iso.datetime().nullable(),
	pastDue: z.boolean().default(false),
	trialEndsAt: z.iso.datetime().nullable(),
})

export type SubscriptionAccessDataSchema = z.infer<typeof subscriptionAccessDataSchema>
